module.exports = __webpack_public_path__ + "media/images/abs-371cec580bb99b35189c2313f6f72dc3.png";